<template>
  <BaseDialog
    ref="baseDialogCreateLLQuote"
    windowClass="pa-0 pb-xl-0 retrieve-quote"
    contentClass="dialog-create-quote"
    :maxWidth="600"
    headerDivider
    :header="false"
    persistent
  >
    <template v-slot:content="{}">
      <ValidationObserver ref="observer" v-slot="{ invalid, validate }">
        <header class="d-flex align-center">
          <h2 class="dialog-title ma-0 mr-auto text-bold font-28">
            Type of Landlord
          </h2>
          <v-btn icon class="btn-close" aria-label="Close" @click="cancel">
            <img src="@/assets/icons/ic_close.svg" />
          </v-btn>
        </header>
        <v-divider></v-divider>
        <v-form
          id="new-quote-form"
          ref="submitForm"
          @submit.prevent="validate().then(() => onSubmit(invalid))"
        >
          <main>
            <p>
              Are you insuring this property as a private landlord or as a
              limited company?
            </p>
            <div class="button-container">
              <v-btn
                depressed
                rounded
                :class="[
                  quoteTypeSelected === 'landlord' ? 'active' : '',
                  $vuetify.breakpoint.xs ? 'flex-column mb-3' : '',
                ]"
                type="button"
                class="landlord-quote"
                :ripple="false"
                @click="buttonClicked('landlord')"
              >
                Landlord
              </v-btn>
              <v-btn
                depressed
                rounded
                :class="quoteTypeSelected === 'company' ? 'active' : ''"
                type="button"
                class="company-quote"
                :ripple="false"
                @click="buttonClicked('company')"
              >
                Company
              </v-btn>
            </div>
            <div
              class="text-field-container col-12 col-md-12 pa-0 mb-5"
              v-if="showCompanyInput"
            >
              <BaseInput
                :rules="{
                  required: { required: true, fieldLabel: 'Company name' },
                  max: { fieldLabel: 'Company name', length: 100 },
                }"
                hide-details="auto"
                hideValidationIcon
                vid="company-name"
                label="Please confirm the company name in full"
                labelClass="company-name-label"
                name="Company Name"
                fieldName="companyName"
                class="company-input"
                :dense="$vuetify.breakpoint.lgAndUp"
                v-model="companyName"
                @input="inputCompanyName"
              />
              <div class="alert d-flex flex-no-wrap">
                <div class="mr-3">
                  <v-icon color="#000000">mdi-alert-circle</v-icon>
                </div>
                <div>
                  <span
                    >If insuring as a limited company/business you should be a
                    principal, director or partner of the business.</span
                  >
                </div>
              </div>
            </div>
            <footer>
              <v-row no-gutters>
                <v-col cols="12" class="text-center pa-0 pb-1 mt-2">
                  <BaseButton
                    text="CONTINUE"
                    height="60"
                    depressed
                    rounded
                    :ripple="false"
                    :minWidth="$vuetify.breakpoint.lgAndUp ? '420' : '100%'"
                    color="mustard"
                    type="submit"
                    class="font-weight-bold font-20 rounded-pill px-10 submit-btn"
                    :disabled="invalid"
                  />
                </v-col>

                <v-col cols="12" class="text-center"
                  ><a @click="cancel" class="font-18"><u>Cancel</u></a></v-col
                >
              </v-row>
            </footer>
          </main>
        </v-form>
      </ValidationObserver>
    </template>
  </BaseDialog>
</template>
<script>
import BaseDialog from "@/components/BaseComponents/BaseDialog";
import BaseInput from "@/components/BaseComponents/BaseInput.vue";
import BaseButton from "@/components/BaseComponents/BaseButton.vue";
import { INSURED_PARTY } from "@/constants/common.constants";
import { ValidationObserver } from "vee-validate";

export default {
  name: "CreateLLQuote",
  components: {
    BaseButton,
    BaseInput,
    ValidationObserver,
    BaseDialog,
  },
  props: {
    insuredParty: String,
    businessName: String,
  },
  data() {
    return {
      indexOfContentExpand: -1,
      showCompanyInput: false,
      quoteTypeSelected: "landlord",
      companyName: "",
      isValid: false,
    };
  },
  watch: {
    insuredParty(value) {
      this.quoteTypeSelected =
        value === INSURED_PARTY.Business ? "company" : "landlord";
      this.showCompanyInput = this.quoteTypeSelected === "company";
    },
    businessName(value) {
      this.companyName = value;
    },
  },

  mounted() {
    if (this.insuredParty) {
      this.quoteTypeSelected =
        this.insuredParty === INSURED_PARTY.Business ? "company" : "landlord";
      this.showCompanyInput = this.quoteTypeSelected === "company";
    }
    this.companyName = this.businessName;
    this.open();
  },

  methods: {
    open() {
      this.$refs.baseDialogCreateLLQuote.open();
    },
    cancel() {
      this.$refs.baseDialogCreateLLQuote.cancel();
      this.$emit("cancel");
    },
    inputCompanyName(val) {
      this.companyName = val;
    },
    async onSubmit(invalid) {
      if (invalid) {
        return;
      }
      this.$emit("companyName", this.companyName);
      this.$emit("quoteTypeSelected", this.quoteTypeSelected);
      this.$refs.baseDialogCreateLLQuote.cancel();
      this.$emit("openEligibilityDialog", this.showCompanyInput);
    },
    buttonClicked(buttonType) {
      if (buttonType === "company") {
        this.showCompanyInput = true;
        this.quoteTypeSelected = "company";
      } else {
        this.showCompanyInput = false;
        this.quoteTypeSelected = "landlord";
        this.companyName = "";
      }
    },
    expandContent(index) {
      this.indexOfContentExpand = index;
    },
    closeExpandContent() {
      this.indexOfContentExpand = -1;
    },
  },
};
</script>

<style lang="scss" scoped>
header {
  padding: 33px 37px 24px;
}

main {
  color: $black-2;
  padding: 35px 37px;
  padding-bottom: 0px !important;
  overflow-y: hidden;
  .alert {
    padding-top: 11px;
    font-size: 16px !important;
  }

  p {
    font-size: 18px !important;
    margin-bottom: 19px;
  }
  .company-input {
    padding-top: 8px !important;
    :deep(.company-name-label) {
      font-size: 18px !important;
      font-weight: 500 !important;
    }
    :deep(.v-text-field__details) {
      padding-left: 0px;
      margin-bottom: 0px;
      span {
        line-height: normal;
      }
    }
  }

  ul {
    list-style: none;
    margin: 0;
    padding: 0;

    li {
      margin-bottom: 31px;

      &:last-child {
        margin-bottom: 0;
      }

      span {
        background: var(--v-accent-base);
        border-radius: 50%;
        font-size: 18px;
        font-weight: 800;
        height: 28px;
        margin-right: 24px;
        width: 28px;

        display: flex;
        justify-content: center;
        align-items: center;
      }
      p {
        margin: 0;
      }
      .action__item {
        color: #106175;
        .v-icon {
          color: #106175;
        }
      }
    }
  }

  .button-container {
    display: flex;
    justify-content: space-between;
    padding-bottom: 13px;
    .landlord-quote {
      width: 49%;
    }
    .company-quote {
      width: 47%;
    }
    .v-btn {
      background-color: #ffffff;
    }
  }

  .v-btn {
    font-size: 20px !important;
    min-height: 48px;
    border-radius: 34px;
    color: #2a2a2a;
    border: 1px solid #7c869a;
    font-size: 20px;
    background: white;
    text-transform: none;
    margin-bottom: 14px;

    &.active {
      font-weight: bold;
      color: #ffffff;
      border-color: #7c869a;
      background-color: #7c869a;
    }
    &:hover {
      border-color: #7c869a;
      background-color: #7c869a;
      color: #ffffff;
    }
  }
  .submit-btn {
    color: #272727 !important;
    &:hover {
      opacity: 0.8;
    }
  }
  .alert {
    font-size: small;
  }

  footer {
    .v-btn {
      &.v-size--x-large {
        color: $black-2;
        height: 60px !important;
      }
    }
    .theme--light.v-btn.v-btn--disabled.v-btn--has-bg {
      background-color: #fab519 !important;
      color: $black-2 !important;
      opacity: 0.5 !important;
      border: none !important;
    }

    a {
      color: $black-2;
    }
  }
}

// xs breakpoint
@media screen and (max-width: 600px) {
  header {
    padding: 26px;
  }
  main {
    padding: 22px 26px;
  }

  .wrap-new-quote-form {
    padding: 30px 24px;
  }

  footer {
    .v-btn {
      &.v-size--x-large {
        margin-top: 5px;
        width: 100%;
        margin-bottom: 14px;
      }
    }
  }
}

// sm breakpoint plus
@media screen and (min-width: 600px) {
  footer {
    .v-btn {
      &.v-size--x-large {
        margin-top: 13px;
        max-width: 420px;
        width: 100%;
        padding: 0 !important;
      }
    }
  }
}
</style>
